const getDiscountInput = (button) =>
  button
    .closest(".ih-cart-discount-row")
    ?.querySelector('cart-discount-field input:not([type="hidden"])');

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-ih-discount-apply]");
  if (!button) return;

  const input = getDiscountInput(button);
  if (!input || !input.value.trim()) {
    input?.focus();
    return;
  }

  button.classList.add("is-loading");
  button.setAttribute("aria-busy", "true");

  input.dispatchEvent(new Event("input", { bubbles: true }));
  input.dispatchEvent(new Event("change", { bubbles: true }));
  input.dispatchEvent(
    new KeyboardEvent("keydown", {
      key: "Enter",
      code: "Enter",
      keyCode: 13,
      which: 13,
      bubbles: true,
      cancelable: true
    })
  );

  window.setTimeout(() => {
    button.classList.remove("is-loading");
    button.removeAttribute("aria-busy");
  }, 2200);
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Enter") return;
  const input = event.target.closest(".ih-cart-discount-row input:not([type='hidden'])");
  if (!input) return;

  const button = input.closest(".ih-cart-discount-row")?.querySelector("[data-ih-discount-apply]");
  if (button) {
    window.setTimeout(() => {
      button.classList.add("is-loading");
      button.setAttribute("aria-busy", "true");
    }, 0);
  }
});

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-ih-discount-apply]");
  if (!button) return;

  const label = button.querySelector("span:first-child");
  if (!label || button.dataset.originalLabel) return;

  button.dataset.originalLabel = label.textContent;
  label.textContent = "Applying…";

  window.setTimeout(() => {
    if (document.body.contains(button)) {
      label.textContent = button.dataset.originalLabel;
      delete button.dataset.originalLabel;
    }
  }, 2300);
});

const ihRefreshCartDrawer = (html, cart) => {
  if (!html) return false;
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const nextDrawer = doc.querySelector("#cart-drawer");
  const currentDrawer = document.querySelector("#cart-drawer");
  if (!nextDrawer || !currentDrawer) return false;

  currentDrawer.innerHTML = nextDrawer.innerHTML;
  currentDrawer.className = nextDrawer.className;
  currentDrawer.setAttribute("data-cart-has-discount", nextDrawer.getAttribute("data-cart-has-discount") || "false");

  document.querySelectorAll("cart-count").forEach((count) => { count.textContent = cart.item_count; });
  document.querySelectorAll("cart-dot").forEach((dot) => { dot.classList.toggle("is-visible", cart.item_count > 0); });
  return true;
};

document.addEventListener("click", async (event) => {
  const removeLink = event.target.closest("[data-ih-remove-line]");
  if (!removeLink) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  if (removeLink.dataset.removing === "true") return;
  const lineKey = removeLink.dataset.lineKey;
  if (!lineKey) return;

  removeLink.dataset.removing = "true";
  removeLink.setAttribute("aria-busy", "true");
  const item = removeLink.closest(".ih-cart-item");
  if (item) { item.style.pointerEvents = "none"; item.style.opacity = ".48"; }

  try {
    const root = window.Shopify?.routes?.root || "/";
    const response = await fetch(root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0,
        sections: "cart-drawer",
        sections_url: window.location.pathname + window.location.search
      })
    });
    if (!response.ok) throw new Error("Unable to remove cart item");

    const cart = await response.json();
    let refreshed = ihRefreshCartDrawer(cart.sections && cart.sections["cart-drawer"], cart);

    if (!refreshed) {
      const joiner = window.location.search ? "&" : "?";
      const fallbackResponse = await fetch(window.location.pathname + window.location.search + joiner + "section_id=cart-drawer");
      const fallbackHtml = await fallbackResponse.text();
      refreshed = ihRefreshCartDrawer(fallbackHtml, cart);
    }

    document.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: { baseEvent: "line-item:remove", cart: cart }
    }));
  } catch (error) {
    console.error("[Indie Cart] Remove failed", error);
    if (item) { item.style.pointerEvents = ""; item.style.opacity = ""; }
    removeLink.dataset.removing = "false";
    removeLink.removeAttribute("aria-busy");
  }
}, true);


const ihSyncHeaderCartBadge = (cart) => {
  if (!cart || typeof cart.item_count !== "number") return;

  document.querySelectorAll(".header__cart-count-badge").forEach((badge) => {
    const count = badge.querySelector("cart-count");
    if (count) count.textContent = cart.item_count > 99 ? "99+" : cart.item_count;

    badge.classList.toggle("is-visible", cart.item_count > 0);
    badge.classList.remove("is-bumping");

    if (cart.item_count > 0) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => badge.classList.add("is-bumping"));
      });
    }
  });
};

document.addEventListener("cart:change", (event) => {
  ihSyncHeaderCartBadge(event.detail?.cart);
});
